import React, { useState, useRef } from "react";

import {
  Button,
  colors,
  Container,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";

import { uri } from "../../../../help/Api";
import TotalCard from "../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
  useStylesSpDial,
  useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import ItemsMoveForm from "./ItemsMoveForm";
import ItemsMoveTable from "./ItemsMoveTable";
import { sto } from "../../../../Context/InshData";
import { GetItemFromOptions } from "../../../../services/global-services";
import { handleInputSearchItems, viewItemsHandle } from "../../../Invs/BackEnd/components/SearchItemsFunction";
import { useStylesSafes } from "../SarfTwreed/SarfTwreed";


export default function ItemsMove(props) {
  const { AutoOptions, AutoOptionsB } = props;
  const { t } = useTranslation(["forms", "translation"]);
  const SafesEmp = AutoOptionsB?.SafeEmp ? AutoOptionsB?.SafeEmp : AutoOptionsB.Safes;
  const optionsSafeUser = SafesEmp.filter((obj) => obj.branch == sto.branchi);
  const optionsSafesAdmins = AutoOptionsB.Safes.filter((obj) => obj.branch == sto.branchi);
  const [OptionsSafes, setOptionsSafes] = useState(() => {
    return sto.User_typei == 1 ? [{ id: -1, name: t("all"), branch: -1 }, ...optionsSafesAdmins] : [...optionsSafeUser];
  });
  const defBranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches);

  const type_mount = [
    { id: 0, name: t("equal") },
    { id: 1, name: t("greater-or-equal") },
    { id: 2, name: t("less-or-equal") },
    { id: 3, name: t("not-equal") },
  ];

  const type_doc = [
    { id: '', name: t("all") },
    { id: '01', name: t("purchases") },
    { id: '02', name: t("sales") },
    { id: '11', name: t("purchase-return") },
    { id: '12', name: t("sales-return") },
    { id: '22', name: t("opening-stock") },
    { id: '23', name: t("store-supply") },
    { id: '24', name: t("store-disburse") },
    { id: '25', name: t("store-transfer") },
    { id: '26', name: t("store-receive") },
    { id: '27', name: t("stock-settlement") },
  ];
  const defaultValues = {
    dateFrom: moment(new Date()).format('YYYY-MM-DD'),
    dateTo: moment(new Date()).format('YYYY-MM-DD'),
    branch: defBranch,
    safe: optionsSafeUser[0],
    curr: { id: -1, name: '' },
    center: AutoOptions?.center[0],
    doc_type: type_doc[0],
    type_mount:type_mount[0],
    price:'',
  }
  let from_date = moment(new Date()).subtract().format("YYYY") + "-01-01";
  const [rptParams, setRptParams] = React.useState({ ...defaultValues, dateFrom: from_date });
  const classes = useStylesSafes();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();

  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const searchTimeout = useRef(null);
  const countItem = AutoOptionsB?.items?.length === 250  || AutoOptionsB?.items?.length === 400 ? true : false;

  const [optionsItemsSearch, setOptionsItemsSearch] = useState(AutoOptionsB.items);
  const [listItemsDownload, setListItemsDownload] = useState([]);
  const viewHandle = async () => {

    setData([]);
    setFetching(true);
    await axios
      .get(
        uri +
        `RptSafes/ItemsDetails?branch=${rptParams.branch.id}
    &&safe=${rptParams.safe?.id}
    &&curr_id=${rptParams.curr?.id}
    &&center=${rptParams.center?.id}
    &&doc_type=${rptParams.doc_type?.id}
    &&dateF=${rptParams.dateFrom}
    &&dateT=${rptParams.dateTo}&&typeMount=${rptParams.type_mount?.id}&&price=${rptParams.price}`
      )
      .then((res) => {
        setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        viewHandle2();
      });
  };
  const viewHandle2 = async () => {

    setData([]);
    setFetching(true);
    await axios
      .get(
        uri +
        `RptSafes/ItemsDetails?branch=${rptParams.branch.id}
    &&safe=${rptParams.safe?.id}
    &&curr_id=${rptParams.curr?.id}
    &&center=${rptParams.center?.id}
    &&doc_type=${rptParams.doc_type?.id}
    &&dateF=${rptParams.dateFrom}
    &&dateT=${rptParams.dateTo}`
      )
      .then((res) => {
        setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        viewHandleOld();
      });
  };
  const viewHandleOld = async () => {

    setData([]);
    setFetching(true);
    await axios
      .get(
        uri +
        `RptSafes/ItemsDetails?branch=${rptParams.branch.id}
    &&safe=${rptParams.safe?.id}
    &&curr_id=${rptParams.curr?.id}
    &&dateF=${rptParams.dateFrom}
    &&dateT=${rptParams.dateTo}`
      )
      .then((res) => {
        setData(res.data);
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        // toast.err("Fetch error");
        setData([]);
      });
  };
  const his = useHistory();
  const printHandle = () => {
    if (data.length == 0) {
      alert(t("no-data"));
    } else {
      const info = {
        data: data?.itemsDetails,
        tot: data?.totals,
        from: t("specific-item-movement"),
        fDate: rptParams.dateFrom,
        tDate: rptParams.dateTo,
        kind: 2,
        nDate: moment(new Date()).format("YYYY-MM-DD"),
        branch: rptParams.branch?.name,
        safe: rptParams.safe?.name,
        curr: rptParams.curr?.name,
      };
      localStorage.setItem("iInfos", JSON.stringify(info));
      his.push({ pathname: "/ReviewActivity" });
      window.location.reload(true);
    }
  };

  let excel_name = "ItemMovementReport";

  const excelHeaders = [
    { label: t("movement-type"), key: "Name_Trans", },
    { label: t("safe"), key: "Name_Safe", },
    { label: t("invoice-no"), key: "id", },
    { label: t("date"), key: "date", },
    { label: t("quantity"), key: "val", },
    { label: t("price"), key: "exchange_price", },
    { label: t("total"), key: "total", },
    { label: t("note"), key: "Name_Customer", },
    { label: t("branch"), key: "Name_Branche", },
  ];

  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeAutoData = (propName, newValue) => {
    if (propName === "branch") {
      const SafesEmp = AutoOptionsB?.SafeEmp ? AutoOptionsB?.SafeEmp : AutoOptionsB.Safes;
      const optinsSafeBranches = SafesEmp.filter((obj) => obj.branch == newValue.id);
      if (optinsSafeBranches !== null) {
        setRptParams({ ...rptParams, [propName]: newValue, safe: optinsSafeBranches[0] });
        setOptionsSafes(sto.User_typei == 1 ? [{ id: -1, name: t("all"), branch: -1 }, ...optinsSafeBranches] : [...optinsSafeBranches]);
      } else {
        const optinsSafeThis = SafesEmp.filter((obj) => obj.branch == sto.branchi);
        setRptParams({ ...rptParams, [propName]: defBranch, safe: optinsSafeThis[0] });
      }
    } else if (propName === "curr") {
      setSearchText("");
      setRptParams({ ...rptParams, [propName]: newValue });
      const newSelect = AutoOptionsB?.items.find((obj) => obj.barcode.toString() === newValue.barcode.toString());
      if (!newSelect) { setListItemsDownload([newValue, ...listItemsDownload]); }
    }
    else {
      setRptParams({ ...rptParams, [propName]: newValue });
    }
  };
  const [searchText, setSearchText] = useState("");

  const handleInputSearch = (event, newValue, reason) => {
    setSearchText(newValue);
    const AllOptions = [{ id: -1, name: t("all"), nameE: "", barcode: "" }, ...AutoOptionsB?.items, ...listItemsDownload];
    handleInputSearchItems(newValue, AllOptions, searchTimeout, setOptionsItemsSearch, countItem, true, reason);
  };
  const handleIconSearch = () => {
    if (countItem && searchText != "") {
        viewItemsHandle('', searchText, setOptionsItemsSearch);
    }
  };
  const handleInputSearchBarcde = (event, newValue, reason) => {
    const AllOptions = [{ id: -1, name: t("all"), nameE: "", barcode: "" }, ...AutoOptionsB?.items, ...listItemsDownload];
    handleInputSearchItems(newValue, AllOptions, searchTimeout, setOptionsItemsSearch, countItem, false, reason);
  };

  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          color="primary"
        >
          {t("movement_of_specific_item_report")}
        </Typography>
      </Grid>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingBottom: "0px",
            borderBottomColor: colors.blue[300],
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <ItemsMoveForm
            {...{
              AutoOptions,
              rptParams,
              onChangeData,
              onChangeAutoData,
              type_doc,
              OptionsSafes,
              handleInputSearch,
              optionsItemsSearch,
              handleInputSearchBarcde,
              type_mount,
              searchText,
              handleIconSearch
            }}
          />
          <Grid
            container
            justifyContent="center"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            spacing={1}
          >
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                size="large"
                style={
                  (inshst.purch.iconBtn,
                    { borderRadius: 0 })
                }
                className={[clasui.button]}
                onClick={() => viewHandle()}
              >
                {t("forms:view")}
              </Button>
            </Grid>
            <Grid item >
              {data && !fetching && data.itemsDetails && (
                <CSVLink
                  separator={";"}
                  filename={excel_name}
                  data={data.itemsDetails}
                  headers={excelHeaders}
                >
                  {" "}
                  <Button
                    disabled={fetching}
                    variant="contained"
                    startIcon={<TableChart />}
                    size="large"
                    color="primary"
                    style={{ borderRadius: 0 }}
                    className={[clasui.button]}
                  >
                    {t("excel_export")}{" "}
                  </Button>
                </CSVLink>
              )}
            </Grid>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={[clasui.button, clasSp.clSec]}
                style={
                  (inshst.purch.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={printHandle}
              >
                {t("forms:print")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={
                  (inshst.purch.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={() => his.goBack()}
              >
                {t("forms:exit")}
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container spacing={1} style={{ paddingTop: "10px" }}>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: classes.purchTotalCard,
                  title: t("count_row"),
                  value: data?.totals?.countRow,
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: classes.purchTotalCard,
                  title: t("total_balance_of_period"),
                  value: data?.totals?.totSal.toFixed(2),
                }}
              />
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
          }}
        >
          <Grid container justifyContent="center">
            <Grid item container justifyContent="center" xs={12}>
              <BeatLoader loading={fetching} color={colors.green[300]} />
              {!fetching && (
                <ItemsMoveTable
                  {...{
                    data: data?.itemsDetails ? data.itemsDetails : [],
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      </Typography>
    </div>
  );
}
